import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const servicedeskCmdbInsightObject4Route: InvariantJiraRoute = {
	name: 'servicedesk-cmdb-object',
	path: '/jira/servicedesk/insight/assets/:objectId',
};
